import algoliasearch from "algoliasearch";
import instantsearch from 'instantsearch.js';

import {CONFIG} from "../config";
import orderResults from "./response/order_results";
import addResultType from "./response/add_result_type";
import {prepareFacets} from "./facets_processors/prepare_sidebar_facets";
import {enforceTypeFacets} from "./response/enforce_type_facets";

export const client = algoliasearch(CONFIG.algolia.appID, CONFIG.algolia.apiKey);
export const index = client.initIndex(CONFIG.algolia.indexName);

export const search = instantsearch({
    indexName: CONFIG.algolia.indexName,
    searchClient: client,
});


const doSearch = (query, filters = [], yearRange = {min: '', max: ''}, currenPage) => {
    filters = filters.join(' AND ');

    const minMax = [];

    if (yearRange.min) {
        minMax.push(`__year >= ${yearRange.min}`)
    }

    if (yearRange.max) {
        minMax.push(`__year <= ${yearRange.max}`)
    }

    if (minMax.length) {
        filters = (filters ? `(${filters}) AND ` : '') + (minMax.length ? `(${minMax.join(' AND ')})` : '')
    }

    // filters = (filters ? `${filters} AND` : '') + ` __year >= 1990 AND __year <= 2021`
    // console.log(filters, minMax);

    const requestOptions = {
        facets: '*',
        hitsPerPage: 50,
        page: currenPage,
        attributesToRetrieve: [
            'objectID', 'title', 'caption', 'description', 'alt', 'thumbnail',
            'size', 'creator', 'rights', 'person_in_image', 'event', 'tags', '__date', 'post_id',
            '__type'
        ],

        filters,

        // hitsPerPage: this.hitsPerPage,
        // page: this.currentPage,
        // facets: this.availableFacets,
        // ignorePlurals: true,
        // maxFacetHits: 100,
        // sortFacetValuesBy: 'alpha',
    };

    /*

    const type = active.filter(f => f).find(f => facets[f].facetGroup === '__type');

    if (facets[type]?.facet !== 'attachment_image') {
        const exclude = ` ( NOT __in_gallery:false ) `;
        requestOptions.filters = exclude + (requestOptions.filters.length ? ` AND ( ${requestOptions.filters} )` : '');
    }
    */

    return index.search(query, requestOptions)
        .then(orderResults)
        .then(addResultType)
        .then(enforceTypeFacets)
        .then(results => {
            const data = {
                facets: prepareFacets(results.facets, results.facets_stats),
                results: results.hits,
                _meta: results
            };

            return data;
        });
};

export default doSearch;